import React from 'react';

export default function SwipeTutorial({ visible }) {
  if (!visible) return null;

  return (
    <aside className="swipe-tutorial swipe-tutorial--center" role="status" aria-live="polite">
      <div className="swipe-tutorial-scrim" aria-hidden="true"/>
      <div className="swipe-tutorial-stage">
        <span className="swipe-tutorial-kicker">MUSEUM GUIDE</span>
        <div className="swipe-tutorial-gesture" aria-hidden="true">
          <i className="swipe-tutorial-arrow">↑</i>
          <i className="swipe-tutorial-trail"/>
          <i className="swipe-tutorial-touch"/>
          <svg className="swipe-tutorial-hand" viewBox="0 0 64 82" fill="none">
            <path d="M29 6c-4.2 0-7.5 3.4-7.5 7.5V37l-3.7-5.7c-2.2-3.4-6.7-4.4-10.1-2.2-3.2 2.1-4.3 6.3-2.5 9.7l12.9 24.4c3 5.7 8.9 9.3 15.3 9.3h7.7c8 0 14.8-5.8 16.1-13.7l2.6-15.7c.8-4.7-2.4-9.1-7.1-9.9-2.1-.3-4.1.1-5.8 1.2v-5.7c0-4.3-3.5-7.8-7.8-7.8-1.5 0-2.9.4-4.1 1.2v-8.6C35 9.4 32.3 6 29 6Z" fill="currentColor"/>
            <path d="M29 12.5v28.8M35 25.5v15.8M46.8 37.3 45.5 46" stroke="#111" strokeWidth="2.5" strokeLinecap="round" opacity=".24"/>
          </svg>
        </div>
        <strong className="swipe-tutorial-title"><span>上スワイプで</span><span>ミュージアム内を歩こう</span></strong>
        <span className="swipe-tutorial-sub">指を上へ動かして、次のショーケースへ</span>
      </div>
    </aside>
  );
}
